import { PaymentMethodEnum, UserRoleEnum, VoucherTypeEnum } from 'generated/api'

export interface IFilter {
  label: string
  value: VoucherTypeEnum | UserRoleEnum | PaymentMethodEnum
}

export const qucikVoucherTags: IFilter[] = [
  { label: 'Khusus ', value: VoucherTypeEnum.Private },
  { label: 'Petani', value: UserRoleEnum.Agent },
  { label: 'BRIVA', value: PaymentMethodEnum.Briva },
]

export const targetFilterVoucher: IFilter[] = [
  { label: 'Umum', value: VoucherTypeEnum.Public },
  { label: 'Khusus', value: VoucherTypeEnum.Private },
]

export const userFilterVoucher: IFilter[] = [
  { label: 'Pemanen', value: UserRoleEnum.Harvester },
  { label: 'Pengemudi', value: UserRoleEnum.Driver },
  { label: 'Kordinator Lapangan', value: UserRoleEnum.FieldCoordinator },
  { label: 'Petani', value: UserRoleEnum.Agent },
]

export const paymentMethodFilterVoucher: IFilter[] = [
  { label: 'BRIVA', value: PaymentMethodEnum.Briva },
  { label: 'Mandiri VA', value: PaymentMethodEnum.Mandiriva },
]
